if (!customElements.get("pcard-swatch")) {
  class ProductCardColorSwatch extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-pcard-variant-picker]",
        optionNodes: [".m-product-option--node__label"],
        featuredImage: ".m-product-card__main-image",
        pcard: ".m-product-card",
        variantDropdown: ".m-product-option--dropdown-select",
        priceWrapper: ".m-price",
        salePrice: ".m-price-item--sale",
        compareAtPrice: [".m-price-item--regular"],
        regularPriceLabel: "[data-regular-price-label]",
        salePriceLabel: "[data-sale-price-label]",
        compareAtPriceLabel: "[data-compare-price-label]",
        unitPriceLabel: "[data-unit-price-label]",
        unitPrice: ".m-price__unit",
        offerNote: "[data-discount-offer-note]",
        soldOutBadge: ".m-product-tag--soldout",
        saleBadge: ".m-product-tag--sale"
      };
      this.container = this.closest(this.selectors.container);
      this.pcard = this.closest(this.selectors.pcard);
      this.variantIdNode = this.pcard && this.pcard.querySelector('[name="id"]');
      this.featuredImage = this.pcard && this.pcard.querySelector(this.selectors.featuredImage);
      this.domNodes = queryDomNodes(this.selectors, this.pcard);
      this.initializeData();
    }

    get disableSelectedVariantByDefault() {
      return this.dataset.disableSelectedVariantByDefault === "true";
    }

    async initializeData() {
      this.variantData = this.fetchVariantData();
      this.productHandle = this.container.dataset.productHandle;
      this.productData = await this.fetchProductJson();
      this.activeOptionNodeByPosition = {};
      this.hideUnavailableProductOptions = MinimogSettings.hide_unavailable_product_options;

      const { variantIdNode, productData, productData: { variants } = {} } = this;

      if (productData) {
        let currentVariantId = variantIdNode && Number(variantIdNode.value);
        if (!currentVariantId) {
          currentVariantId =
            productData.selected_or_first_available_variant && productData.selected_or_first_available_variant.id;
        }
        const currentVariant = variants.find((v) => v.id === currentVariantId) || variants[0];
        this.productData.initialVariant = currentVariant;
        if (!this.productData.selected_variant && variantIdNode && variantIdNode.dataset.selectedVariant) {
          this.productData.selected_variant = variants.find(
            (v) => v.id === Number(variantIdNode.dataset.selectedVariant)
          );
        }

        if (!this.disableSelectedVariantByDefault) {
          this.updateOptionsByVariant(currentVariant);
          this.updateProductImage(currentVariant);
          window.MinimogEvents.subscribe("m:image-loaded", () => {
            this.updateProductImage(currentVariant);
          });
        }
      }

      if (this.domNodes.optionNodes) {
        this.domNodes.optionNodes.forEach((node) =>
          node.addEventListener("click", this.handleVariantSelection.bind(this))
        );
      }
      if (this.domNodes.variantDropdown) {
        this.domNodes.variantDropdown.addEventListener("change", this.handleVariantSelection.bind(this));
      }
    }

    fetchVariantData() {
      if (!this.variantData) {
        var jsonElement = this.container && this.container.querySelector('[type="application/json"]');
        this.variantData = JSON.parse(jsonElement ? jsonElement.textContent : "{}");
      }
      return this.variantData;
    }

    fetchProductJson() {
      var productUrl = `${window.MinimogSettings.routes.root}/products/${this.productHandle}.js`;
      productUrl = productUrl.replace("//", "/");
      return fetch(productUrl).then(function (response) {
        return response.json();
      });
    }

    toggleOptionNodeActive(optNode, active) {
      if (!optNode) return;
      if (active) {
        const { optionPosition, value: optionValue } = optNode.dataset;
        this.activeOptionNodeByPosition[optionPosition] = optNode;

        switch (optNode.tagName) {
          case "INPUT":
            optNode.checked = true;
            optNode.dataset.selected = "true";
            break;
          case "OPTION":
            optNode.dataset.selected = "true";
            const select = optNode.closest("select");
            if (select) select.value = optNode.value;
            break;
          case "LABEL":
            optNode.dataset.selected = "true";
            break;
          default:
            if (!optNode.classList.contains("m-product-quickview-button")) {
              console.warn("Unable to activate option node", optNode);
            }
            break;
        }

        this.updateSoldOutBadge(this.getVariantsByOptionValue(optionValue));
      } else {
        if (!["default", "image", "color"].includes(optNode.dataset.optionType)) {
          optNode.style.border = "";
        }
        optNode.checked = false;
        delete optNode.dataset.selected;
        const select = optNode.closest("select");
        if (select) select.value = "";
      }
    }

    updateOptionsByVariant(variant) {
      Object.values(this.activeOptionNodeByPosition).forEach((optNode) => this.toggleOptionNodeActive(optNode, false));

      const { optionNodes } = this.domNodes;
      const { options = [] } = variant || {};
      options.forEach((option, index) => {
        const optPosition = index + 1;
        optionNodes.forEach((optNode) => {
          const _optPosition = Number(optNode.dataset.optionPosition);
          const _optValue = optNode.dataset.value;

          if (_optPosition === optPosition && option === _optValue) {
            this.toggleOptionNodeActive(optNode, true);
          }
        });
      });
      this.updatePrice(variant);
    }

    getVariantFromActiveOptions = () => {
      const {
        productData,
        productData: { initialVariant },
        activeOptionNodeByPosition,
      } = this;
      const initialVariantOptions = {
        1: initialVariant.option1,
        2: initialVariant.option2,
        3: initialVariant.option3,
      };

      Object.values(activeOptionNodeByPosition).forEach((optNode) => {
        const { optionPosition, value } = optNode.dataset;
        initialVariantOptions[optionPosition] = value;
      });

      var options = Object.values(initialVariantOptions).filter(Boolean);
      var variant = getVariantFromOptionArray(productData, options);
      if (!variant && this.hideUnavailableProductOptions) {
        options.pop();
        variant = getVariantFromOptionArray(productData, options);
        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(productData, options);
        }
      }
      this.currentVariant = variant;
      return variant;
    };

    handleVariantSelection(e) {
      var target = e.target;
      var newVariant;

      if (target.classList.contains("combined-variant")) {
        const variantId = Number(e.target.value);
        newVariant =
          this.productData && this.productData.variants && this.productData.variants.find((v) => v.id === variantId);
      } else {
        if (target.tagName === "SELECT") {
          target = target.querySelectorAll("option")[target.selectedIndex];
        }
        if (!target.classList.contains("m-product-option--node__label")) {
          target = target.closest(".m-product-option--node__label");
          if (!target) console.error("Unable to find option node!");
        }
        const { optionPosition } = target.dataset;

        const currActiveOptNode = this.activeOptionNodeByPosition[optionPosition];
        this.toggleOptionNodeActive(currActiveOptNode, false);
        this.toggleOptionNodeActive(target, true);
        newVariant = this.getVariantFromActiveOptions();
      }

      const { variantIdNode } = this;
      if (variantIdNode) {
        variantIdNode.setAttribute("value", String(newVariant.id));
        variantIdNode.value = String(newVariant.id);
      }

      this.updateBySelectedVariant(newVariant);
      this.updateSaleBadge(newVariant);
    }

    updateBySelectedVariant(variant) {
      if (variant) {
        this.updateProductImage(variant);
        this.updatePrice(variant);
      }
    }

    updateProductCardSoldOutBadge(variant) {
      if (this.domNodes.soldOutBadge) {
        const soldOut = !variant.available;
        this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none";
        this.domNodes.soldOutBadge.textContent = soldOut
          ? this.domNodes.soldOutBadge.dataset.soldOutLabel || ""
          : "";
      }
    }

    updateSoldOutBadge(variants) {
      const soldOut = !variants.some((variant) => variant.available);
      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none";
        this.domNodes.soldOutBadge.textContent = soldOut
          ? this.domNodes.soldOutBadge.dataset.soldOutLabel || ""
          : "";
      }
    }

    updateSaleBadge(variant) {
      if (!variant || !this.domNodes.saleBadge) return;

      const moneyFormat = window.MinimogSettings.money_format;
      const saleBadgeType = this.pcard.dataset.saleBadge

      const { compare_at_price, price, discount_percentage, discount_offer } = this.getDisplayVariant(variant);

      if (discount_offer || !compare_at_price || compare_at_price <= price) {
        this.domNodes.saleBadge.classList.add('!m:hidden');
        this.domNodes.saleBadge.innerHTML = '';
        return;
      }

      this.domNodes.saleBadge.classList.remove('!m:hidden');

      let discount = compare_at_price - price;

      if (saleBadgeType === 'show_text') {
        this.domNodes.saleBadge.innerHTML = this.domNodes.saleBadge.dataset.saleLabel || '';
      } else if (saleBadgeType === 'show_percentage') {
        discount = discount_percentage || Math.round(discount / compare_at_price * 100);
        this.domNodes.saleBadge.innerHTML = `-${discount}%`;

      } else if (saleBadgeType === 'show_fixed_amount') {
        this.domNodes.saleBadge.innerHTML = this.domNodes.saleBadge.dataset.saleFixedLabel || '';
        const saved = this.domNodes.saleBadge.querySelector('.m-currency--saved');
        discount = Math.round(discount);
        if (saved) {
          saved.innerHTML = formatProductMoney(discount, moneyFormat);
        }
      }
    }

    getVariantsByOptionValue = (value) => {
      const { productData: { variants } = {} } = this;
      return variants.filter((variant) => variant.options.includes(value));
    };

    updateProductImage(variant) {
      const src = variant && variant.featured_image && variant.featured_image.src;
      const { featuredImage } = this;
      const img = featuredImage && featuredImage.querySelector("img");

      if (img && src) {
        img.src = `${src}&width=533`;
        img.removeAttribute("srcset");
      }
    }

    updatePrice(variant) {
      const classes = {
        onSale: "m-price--on-sale",
        soldOut: "m-price--sold-out",
      };

      const moneyFormat = window.MinimogSettings.money_format;

      const {
        priceWrapper, salePrice, unitPrice, compareAtPrice, offerNote,
        regularPriceLabel, salePriceLabel, compareAtPriceLabel, unitPriceLabel
      } = this.domNodes;
      const { compare_at_price, price, unit_price, unit_price_measurement, discount_offer } = this.getDisplayVariant(variant);
      if (offerNote) offerNote.hidden = !discount_offer;
      const onSale = compare_at_price && compare_at_price > price;
      const soldOut = !variant.available;

      if (onSale) {
        priceWrapper && priceWrapper.classList.add(classes.onSale);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.onSale);
      }

      if (soldOut) {
        priceWrapper && priceWrapper.classList.add(classes.soldOut);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.soldOut);
      }

      priceWrapper && priceWrapper.classList.remove("visibility-hidden");
      const regularPrice = compareAtPrice && compareAtPrice[0];
      const crossedOutPrice = compareAtPrice && compareAtPrice[1];
      if (salePrice) salePrice.innerHTML = onSale ? formatProductMoney(price, moneyFormat) : "";
      if (regularPrice) regularPrice.innerHTML = onSale ? "" : formatProductMoney(price, moneyFormat);
      if (crossedOutPrice) {
        crossedOutPrice.innerHTML = onSale ? formatProductMoney(compare_at_price, moneyFormat) : "";
      }
      if (regularPriceLabel) {
        regularPriceLabel.textContent = onSale ? "" : regularPriceLabel.dataset.label || "";
      }
      if (salePriceLabel) {
        salePriceLabel.textContent = onSale ? salePriceLabel.dataset.label || "" : "";
      }
      if (compareAtPriceLabel) {
        compareAtPriceLabel.textContent = onSale ? compareAtPriceLabel.dataset.label || "" : "";
      }

      if (unit_price_measurement && unit_price != null && unitPrice && this.currentVariant) {
        unitPrice.classList.remove("f-hidden");
        const unitPriceContent = `<span>${formatProductMoney(
          unit_price,
          moneyFormat
        )}</span>/<span data-unit-price-base-unit>${this.getBaseUnit()}</span>`;
        unitPrice.innerHTML = unitPriceContent;
        if (unitPriceLabel) unitPriceLabel.textContent = unitPriceLabel.dataset.label || "";
      } else {
        unitPrice && unitPrice.classList.add("f-hidden");
        if (unitPrice) unitPrice.innerHTML = "";
        if (unitPriceLabel) unitPriceLabel.textContent = "";
      }
    }

    getDisplayVariant(variant) {
      if (variant.price <= 0) return variant;
      const percentage = Number(this.domNodes.priceWrapper?.dataset.discountPercentage || 0);
      if (!Number.isFinite(percentage) || percentage <= 0 || percentage > 100) return variant;
      const validUntil = Number(this.domNodes.priceWrapper?.dataset.discountValidUntil || 0);
      if (!Number.isSafeInteger(validUntil) || validUntil < 0 || (validUntil > 0 && Date.now() >= validUntil * 1000)) {
        return variant;
      }

      const price = variant.price - Math.round(variant.price * percentage / 100);
      // Display only: leave the catalog variant and cart payload unchanged.
      return {
        ...variant,
        compare_at_price: variant.price,
        price,
        discount_percentage: percentage,
        discount_offer: this.domNodes.priceWrapper?.dataset.discountOffer === "1",
        unit_price: variant.unit_price == null
          ? variant.unit_price
          : this.getDisplayUnitPrice(price, variant.unit_price_measurement),
      };
    }

    getDisplayUnitPrice(price, measurement) {
      if (!measurement) return null;
      // Match product-display-unit-price.liquid; bases are g, ml, mm, m², and items.
      const factors = {
        mg: 0.001, g: 1, kg: 1000, ml: 1, cl: 10, l: 1000, m3: 1000000,
        mm: 1, cm: 10, m: 1000, in: 25.4, ft: 304.8, yd: 914.4,
        oz: 28.349523125, lb: 453.59237, floz: 29.5735295625,
        pt: 473.176473, qt: 946.352946, gal: 3785.411784, m2: 1, ft2: 0.09290304, item: 1,
      };
      const sameUnit = measurement.quantity_unit === measurement.reference_unit;
      const quantity = Number(measurement.quantity_value) * (sameUnit ? 1 : factors[measurement.quantity_unit]);
      const reference = Number(measurement.reference_value) * (sameUnit ? 1 : factors[measurement.reference_unit]);
      if (!Number.isFinite(quantity) || !Number.isFinite(reference) || quantity <= 0 || reference <= 0) return null;
      return Math.round(price * reference / quantity);
    }

    getBaseUnit = () => {
      return this.currentVariant.unit_price_measurement.reference_value === 1
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value +
        this.currentVariant.unit_price_measurement.reference_unit;
    };
  }

  customElements.define("pcard-swatch", ProductCardColorSwatch);
}
